export const REGEX_GROUP_OF_FOUR = /.{1,4}/g;
export const REGEX_ONLY_NUMBERS = /^[0-9]*$/g;
